import $ from 'jquery';
import Framework from 'framework';
import _ from 'ext:lodash';
import selectorConfig from '../config.js';
import constants from 'lib/constants';
import profileStoreIsAvailable from 'lib/profile-store-utils';
import authUtils from "lib/auth-utils";

var accountNav = selectorConfig.accountNav;
var profileVisible = selectorConfig.profileVisible;
var clubAccessVisible = selectorConfig.clubAccessVisible;
var ltBucksValue = selectorConfig.ltBucksValue;
var anonymousVisible = selectorConfig.anonymousVisible;
var logoutLink = selectorConfig.logoutLink;
var loginLabel = selectorConfig.loginLabel;
var ltNavAccount = selectorConfig.ltNavAccount;
var ltAccountToggle = selectorConfig.ltAccountToggle;
var viewAccountDivider = selectorConfig.viewAccountDivider;

function updateFlyout(profile, urlStoreData) {
	//show hide items if the user has a profile
	if((profile.memberState !== constants.memberState.unknown) || (profile.memberState === constants.memberState.unknown && profile.memberDetails)){
		if(profile.memberDetails && profile.memberDetails.firstname){
			$(accountNav).find(profileVisible).removeClass('hidden-xs-up');
			$(accountNav).find(viewAccountDivider).removeClass('hidden-xs-up');
			$(accountNav).find(anonymousVisible).addClass('hidden-xs-up');

			// check for club access key
			const hasClubAccess = _.some(profile.memberDetails.resourceKeys, (obj) => {
				return obj.category === 'clubAccess';
			});

			// if the user has club access, display link to location access page
			if(hasClubAccess) {
				$(accountNav).find(clubAccessVisible).removeClass('hidden-xs-up');
			}

			// check LTBucks balance
			const valBucks = profile.memberDetails.ltBucksBalance;

			// add current balance to the LTBUCK$ link
			if(valBucks >= 0) {
				$(accountNav).find(ltBucksValue).text(': ' + valBucks);
			}
		}else{
			$(loginLabel).html($(loginLabel).data('loginlabel'));
			$(accountNav).find(anonymousVisible).removeClass('hidden-xs-up');
			$(accountNav).find(profileVisible).addClass('hidden-xs-up');
			$(accountNav).find(clubAccessVisible).addClass('hidden-xs-up');
		}
		$(loginLabel).removeClass('hidden-xs-up');
	}else if(Framework.global.lt.pageProperties.experienceType === constants.experienceTypeWorkProspect){
		$(accountNav).find(anonymousVisible).removeClass('hidden-xs-up');
		$(accountNav).find(profileVisible).addClass('hidden-xs-up');
		$(accountNav).find(clubAccessVisible).addClass('hidden-xs-up');
	}
}

function bindLogoutLink() {
	const useB2C = authUtils.isFeatureFlagEnabled('useB2C');
	$(accountNav).find(logoutLink).click(function (event) {
		event.preventDefault();
		if (useB2C && window.ef.b2cStore) {
			window.ef.b2cStore.logout();
		} else {
			// close all flyout menus
			$('.open .dropdown-toggle').dropdown('toggle');
			window.ef.profileStore.logout();
			$(loginLabel).html($(loginLabel).data('loginlabel'));
		}
	});
}

export default class AccountFlyout {
	constructor(ProfileStore, UrlStore) {
		this.ProfileStore = ProfileStore;
		this.UrlStore = UrlStore;
	}

	initialize() {

        if (profileStoreIsAvailable) {
            if (_.isUndefined(this.ProfileStore)) {
                console.error('AccountFlyout component failed to initialize ProfileStore dependency');
            }
            if (_.isUndefined(this.UrlStore)) {
                console.error('AccountFlyout component failed to initialize UrlStore dependency');
            }

            var profileData = this.ProfileStore.getInitialData();
            var urlStoreData = this.UrlStore.getInitialData();
            updateFlyout(profileData, urlStoreData);
            bindLogoutLink();

            this.ProfileStore.listen((profile) => {
                updateFlyout(profile, this.UrlStore.getInitialData());
            });

            this.UrlStore.listen((urlStoreDataListen) => {
                updateFlyout(this.ProfileStore.getInitialData(), urlStoreDataListen);
            });
        }
    }
}
